import React from "react"
import styles from "./trash.module.css"
import Button from "../../components/Form/Button"
import Table from "../../components/Table"
import { useNavigate, useParams } from 'react-router-dom'
import { BsFunnel } from "react-icons/bs"

const Trash = () => {
    const { account_id } = useParams()
    const navigate = useNavigate()

    const headers = [
        "#",
        "Nome",
        "Descrição",
        "",
        "",
    ]

    const data = [
        {
            id: 1,
            value: [
                "Leads",
                "Gerencie seus leads excluídos. Todos os leads serão excluídos permanentemente após 30 dias na lixeira!",
                <BsFunnel className="icon-md" />,
                <Button variant="primary">Acessar</Button>,
            ],
            path: `/${account_id}/trashs/leads`,
        },
    ]

    const handleNavigateToPage = async (id) => {
        data?.forEach(async el => {
            if (el.id === id) {
                navigate(el?.path)
            }
        })
    }

    return (
        <div className={styles.container}>
            <Table
                headers={headers}
                values={data}
                onClick={(id) => handleNavigateToPage(id)}
                messageNotRegisters="Nenhum registro encontrado"
                showIndex={true}
            />
        </div>
    )
}

export default Trash